import "./style"

export default class ComponentsInputsButton extends BaseComponent {
  static defaultProps = {
    darkPrimary: false,
    disabled: false,
    primary: false,
    save: false
  }

  static propTypes = {
    className: PropTypes.string,
    darkPrimary: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    icon: PropTypes.string,
    primary: PropTypes.bool.isRequired,
    save: PropTypes.bool.isRequired,
    small: PropTypes.bool,
    to: PropTypes.string,
    white: PropTypes.bool
  }

  buttonRef = React.createRef()
  shape = new Shape(this, {disabled: 0})

  render() {
    const {className, darkPrimary, disabled, icon, label, primary, save, small, onClick, to, white, ...restProps} = this.props
    const buttonProps = {
      "className": classNames("components--inputs--button", "action-button", className),
      "data-dark-primary": primary,
      "data-disabled": disabled,
      "data-primary": primary,
      "data-save": save,
      "data-small": small,
      "data-white": white,
      "disabled": this.isDisabled(),
      "onClick": this.t.onClick,
      "ref": this.t.buttonRef
    }

    if (to) {
      return (
        <Link to={disabled ? "#" : to} {...buttonProps} {...restProps}>
          {this.labelContent()}
        </Link>
      )
    }

    return (
      <button {...buttonProps} {...restProps}>
        {this.labelContent()}
      </button>
    )
  }

  isDisabled = () => this.s.disabled > 0 || this.p.disabled

  label() {
    if ("label" in this.props) {
      return this.props.label
    } else if (this.props.children) {
      return this.props.children
    } else if (this.props.save) {
      return I18n.t("js.shared.save")
    }

    throw new Error("Couldn't figure out label")
  }

  labelContent() {
    const {icon} = this.props

    return (
      <>
        {icon &&
          <i className={`fa fa-fw fa-${icon} mr-1`} />
        }
        {this.label()}
      </>
    )
  }

  onClick = (e, ...args) => {
    if (this.isDisabled()) {
      e.preventDefault()
      e.stopPropagation()

      return
    }

    this.shape.set({disabled: this.s.disabled + 1})
    setTimeout(this.t.enableButton, 1000)
    if (this.props.onClick) this.p.onClick(e, ...args)
  }

  enableButton = () => this.shape.set({disabled: this.s.disabled - 1})
}
